import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CtaSecOne = ({ className = '' }) => {
  const { t } = useTranslation();

  return (
    <section className={`${className}`} data-bg-src="assets/img/bg/cta_bg_2.png">
      <div className="container">
        <div className="row gy-50 justify-content-center">
          <div className="col-xl-6">
            <div className="title-area mb-0 text-xl-start text-center">
              <span className="sub-title style2" data-cue="slideInUp">{t('sections.ctaSecOne.sub_title','Get in Touch')}</span>
              <h2 className="sec-title" data-cue="slideInUp">
                {t('sections.ctaSecOne.title','Securing Your Digital World With Advanced Cloud Security Solutions')}
              </h2>
              <p className="sec-text mt-30" data-cue="slideInUp">
                {t('sections.ctaSecOne.text','Secur is a pioneering cybersecurity firm dedicated to safeguarding your digital assets. With over two decades of experience.')}
              </p>
              <Link to="/contact" className="ot-btn mb-0 mt-4" data-cue="slideInUp">
                {t('sections.ctaSecOne.contact','Contact Us')} <i className="fas fa-arrow-right ms-2"></i>
              </Link>
            </div>
          </div>
          <div className="col-xl-6 text-center">
            <div className="cta-thumb1-1" data-cue="slideInUp">
              <img src="assets/img/normal/cta1-1.png" alt={t('sections.ctaSecOne.img_alt','img')} />
              <div className="ripple-shape">
                <span className="ripple-1"></span>
                <span className="ripple-2"></span>
                <span className="ripple-3"></span>
                <span className="ripple-4"></span>
                <span className="ripple-5"></span>
                <span className="ripple-6"></span>
                <span className="ripple-7"></span>
                <span className="ripple-8"></span>
                <span className="ripple-9"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSecOne;